module.exports = __webpack_public_path__ + "img/moon-cloud-storm.809dc20.svg";